import React, { useMemo } from 'react'

export default function useMentorClinicRosterData(mentorProfileData, roomId) {
  const chamberRooms = useMemo(() => {
    if (!roomId) return []
    return [
      {
        id: roomId,
        clinicBrandName: 'Clinic',
        clinicLocationName: 'Location',
        title: 'Room',
      },
    ]
  }, [roomId])
  const sidebarLegends = useMemo(() => {
    if (!mentorProfileData) return []
    return [mentorProfileData]
  }, [mentorProfileData])

  return { chamberRooms, sidebarLegends }
}
